var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _g, _path8, _rect3, _g2, _path9, _path10, _rect4, _g3, _path11, _rect5, _path12, _rect6, _rect7, _g4, _path13, _rect8, _g5, _path14, _path15, _rect9, _g6, _path16, _rect10, _path17, _rect11, _rect12, _g7, _path18, _rect13, _g8, _path19, _path20, _rect14, _g9, _path21, _rect15, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeBeaker3Tubes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 259,
    viewBox: "0 0 209 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.397 97.5829C174.747 98.916 173.212 99.6006 171.767 99.2043L169.853 98.6638C164.5 101 164 103 163.839 110V252.839C163.839 256.208 161.094 258.946 157.716 258.946L39.4562 259C36.061 259 33 256.498 33 253.129V92C33 89.55 32.5934 87.3684 31.2209 85.3147C30.4985 83.7655 31.6363 82 33.352 82H153.689C161.401 82 168.769 85.1526 174.079 90.7012C176.011 92.4487 176.553 95.259 175.397 97.5829Z",
    fill: "#D9ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8751 149L107.142 148.949C110.373 148.949 113 146.341 113 143.133V113.5C85.1972 112.539 70.5 108.5 35 108.5L35 143.167C35 146.392 37.6265 149 40.8751 149Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3461 84H37.7872C37.1132 84 36.5667 84.4478 36.5667 85C36.5667 85.5522 37.1132 86 37.7872 86H63.3461C64.0201 86 64.5667 85.5522 64.5667 85C64.5667 84.4478 64.0201 84 63.3461 84Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.21 84H73.7899C72.2492 84 71 84.4478 71 85C71 85.5522 72.2492 86 73.7899 86H132.21C133.751 86 135 85.5522 135 85C135 84.4478 133.751 84 132.21 84Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 117V249.165C35 252.401 37.6242 255.017 40.8699 255L156.078 254.948C159.307 254.948 162 252.219 162 249V109C162 108.415 161.965 107.585 162 107C134.757 107.258 73 117 35 117Z",
    fill: "#66CEF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7024 107H47.2976C46.0274 107 45 108.393 45 110.116V250.921C45 253.176 46.345 255 48.0075 255H56.9925C58.655 255 60 253.176 60 250.921V110.116C60 108.393 58.9726 107 57.7024 107Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0001 248.051C39.0001 248.578 39.4445 249 40.0001 249C40.0743 249 40.1466 248.992 40.2161 248.978C40.2822 248.993 40.3508 249 40.4213 249H48.8192C49.3429 249 49.7763 248.556 49.7944 248C49.7944 247.444 49.361 247 48.8192 247H41.0001V232H48.8192C49.3429 232 49.7763 231.556 49.7944 231C49.7944 230.444 49.361 230 48.8192 230H41.0001V215H48.8192C49.3429 215 49.7763 214.556 49.7944 214C49.7944 213.444 49.361 213 48.8192 213H41.0001V198H48.8192C49.3429 198 49.7763 197.556 49.7944 197C49.7944 196.444 49.361 196 48.8192 196H41.0001V181H48.8192C49.3429 181 49.7763 180.556 49.7944 180C49.7944 179.444 49.361 179 48.8192 179H41.0001V164H48.8192C49.3429 164 49.7763 163.556 49.7944 163C49.7944 162.444 49.361 162 48.8192 162H41.0001V147H48.8192C49.3429 147 49.7763 146.556 49.7944 146C49.7944 145.444 49.361 145 48.8192 145H41.0001V130H48.8192C49.3429 130 49.7763 129.556 49.7944 129C49.7944 128.444 49.361 128 48.8192 128H41.0001V113H49.3731C49.8968 113 50.3303 112.556 50.3483 112C50.3483 111.444 49.9149 111 49.3731 111H41.0001V96H49.3731C49.8968 96 50.3303 95.5556 50.3483 95C50.3483 94.4445 49.9149 94 49.3731 94H40.9752C40.8021 94 40.64 94.0454 40.4996 94.1253C40.353 94.0455 40.1825 94 40.0001 94C39.4445 94 39.0001 94.4218 39.0001 94.949V248.051Z",
    fill: "#668BA6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.659,
    y: 173.975,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-75 104.659 173.975)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 160,
    width: 38,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 107.109,
    y: 172.561,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-75 107.109 172.561)",
    fill: "#99DFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.109,
    y: 172.561,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-75 107.109 172.561)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.204 172.68C110.532 171.696 108.352 167.921 109.336 164.248C110.32 160.575 114.095 158.396 117.768 159.38L148.764 167.685L146.236 177.122C145.664 179.256 143.471 180.522 141.337 179.95L114.204 172.68Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.283 160.452L109.059 157.554L148.662 168.166L147.886 171.063L108.283 160.452Z",
    fill: "#F2F7FC"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.254 167.647C99.4875 167.969 98.6864 167.269 98.9015 166.466L100.462 160.642C100.668 159.872 101.65 159.641 102.178 160.239L105.403 163.893L104.921 165.691L100.254 167.647Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 162,
    width: 4,
    height: 6
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.134,
    y: 163.339,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(105 108.134 163.339)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.134,
    y: 163.339,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(105 108.134 163.339)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.562 162.276C106.872 162.359 107.085 162.642 107.057 162.962C107.013 163.475 106.909 164.296 106.668 165.196C106.427 166.096 106.106 166.859 105.888 167.324C105.752 167.616 105.426 167.755 105.116 167.671C104.742 167.571 104.52 167.187 104.62 166.813L105.703 162.771C105.804 162.397 106.188 162.175 106.562 162.276Z",
    fill: "#EEEEEE"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7308 166.44C97.0335 166.512 96.4799 165.864 96.6613 165.186L97.863 160.702C98.037 160.052 98.7892 159.756 99.3592 160.113L105.403 163.893L104.921 165.691L97.7308 166.44Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.173 181.827C153.676 182.488 154.72 182.283 154.935 181.48L156.495 175.657C156.702 174.886 155.967 174.196 155.211 174.45L150.591 176.001L150.109 177.8L153.173 181.827Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 174,
    width: 4,
    height: 5
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(-0.258819 0.965926 0.965926 0.258819 148.502 174.156)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(-0.258819 0.965926 0.965926 0.258819 148.502 174.156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.396 174.021C150.086 173.938 149.76 174.077 149.624 174.368C149.406 174.834 149.085 175.597 148.844 176.497C148.603 177.397 148.499 178.218 148.455 178.73C148.427 179.05 148.64 179.334 148.95 179.417C149.324 179.517 149.708 179.295 149.809 178.921L150.892 174.879C150.992 174.505 150.77 174.121 150.396 174.021Z",
    fill: "#EEEEEE"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.962 182.043C156.529 182.454 157.333 182.169 157.515 181.492L158.716 177.007C158.89 176.358 158.387 175.725 157.715 175.749L150.591 176.001L150.109 177.8L155.962 182.043Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136.364,
    y: 163.835,
    width: 18,
    height: 12,
    transform: "rotate(105 136.364 163.835)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.638 175.741L129.122 173.933L125.065 172.846L125.329 171.861L130.611 167.822L131.77 168.133L130.391 173.279L131.318 173.527L131.07 174.455L130.142 174.206L129.658 176.014L128.638 175.741ZM126.461 172.226L129.371 173.006L130.396 169.181L126.461 172.226Z",
    fill: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 187,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 54 187)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 171,
    width: 38,
    height: 14
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 185,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 56 185)",
    fill: "#99DFF9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 185,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 56 185)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8846 183.279C59.0823 183.279 56 180.197 56 176.394C56 172.592 59.0823 169.51 62.8846 169.51L94.9744 169.51L94.9744 179.279C94.9744 181.488 93.1835 183.279 90.9744 183.279L62.8846 183.279Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 173L54 170L95 170L95 173L54 173Z",
    fill: "#F2F7FC"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1071 182.028C47.4499 182.537 46.4951 182.068 46.4951 181.237L46.4951 175.208C46.4951 174.411 47.3832 173.934 48.0479 174.375L52.1089 177.069L52.1089 178.931L48.1071 182.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 175,
    width: 3,
    height: 6
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 54.604,
    y: 175.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 54.604 175.828)",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.604,
    y: 175.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 54.604 175.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8098 175.207C53.1312 175.207 53.4099 175.426 53.466 175.742C53.5559 176.248 53.6683 177.068 53.6683 178C53.6683 178.932 53.5559 179.752 53.466 180.258C53.4099 180.575 53.1312 180.793 52.8098 180.793C52.4227 180.793 52.1089 180.479 52.1089 180.092L52.1089 175.908C52.1089 175.521 52.4227 175.207 52.8098 175.207Z",
    fill: "#EEEEEE"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3574 181.515C44.7027 181.766 44 181.282 44 180.581L44 175.938C44 175.266 44.65 174.785 45.2928 174.982L52.1089 177.069L52.1089 178.931L45.3574 181.515Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.893 182.028C103.55 182.537 104.505 182.068 104.505 181.237L104.505 175.208C104.505 174.411 103.617 173.934 102.952 174.375L98.8911 177.069L98.8911 178.931L102.893 182.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 175,
    width: 3,
    height: 6
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 96.3961 175.828)",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 96.3961 175.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1902 175.207C97.8689 175.207 97.5902 175.426 97.534 175.742C97.4442 176.248 97.3317 177.068 97.3317 178C97.3317 178.932 97.4442 179.752 97.534 180.258C97.5902 180.575 97.8689 180.793 98.1902 180.793C98.5773 180.793 98.8911 180.479 98.8911 180.092L98.8911 175.908C98.8911 175.521 98.5773 175.207 98.1902 175.207Z",
    fill: "#EEEEEE"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.643 181.515C106.297 181.766 107 181.282 107 180.581L107 175.938C107 175.266 106.35 174.785 105.707 174.982L98.8911 177.069L98.8911 178.931L105.643 181.515Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 169,
    width: 18,
    height: 12,
    transform: "rotate(90 82 169)",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5146 182.644C74.7026 182.644 73.7066 181.792 73.6826 180.388L74.7146 180.388C74.7506 181.204 75.4106 181.684 76.5026 181.684C77.7146 181.684 78.3866 181.096 78.3866 179.908C78.3866 178.744 77.7386 178.132 76.5866 178.132C75.9266 178.132 75.3986 178.336 74.9186 178.756L73.9466 178.756L74.2226 174.34L79.0706 174.34L79.0706 175.336L75.1706 175.336L75.0146 177.748C75.4946 177.364 76.0946 177.172 76.8266 177.172C78.4826 177.172 79.4426 178.132 79.4426 179.884C79.4426 181.732 78.3866 182.644 76.5146 182.644Z",
    fill: "#333333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 203,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 101 203)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 187,
    width: 38,
    height: 14
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 201,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 103 201)",
    fill: "#99DFF9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 201,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 103 201)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.885 199.279C106.082 199.279 103 196.197 103 192.394C103 188.592 106.082 185.51 109.885 185.51L141.974 185.51L141.974 195.279C141.974 197.488 140.183 199.279 137.974 199.279L109.885 199.279Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 189L101 186L142 186L142 189L101 189Z",
    fill: "#F2F7FC"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1071 198.028C94.4499 198.537 93.4951 198.068 93.4951 197.237L93.4951 191.208C93.4951 190.411 94.3832 189.934 95.0479 190.375L99.1089 193.069L99.1089 194.931L95.1071 198.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 191,
    width: 3,
    height: 6
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 101.604,
    y: 191.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 101.604 191.828)",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.604,
    y: 191.828,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 101.604 191.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8098 191.207C100.131 191.207 100.41 191.426 100.466 191.742C100.556 192.248 100.668 193.068 100.668 194C100.668 194.932 100.556 195.752 100.466 196.258C100.41 196.575 100.131 196.793 99.8098 196.793C99.4227 196.793 99.1089 196.479 99.1089 196.092L99.1089 191.908C99.1089 191.521 99.4227 191.207 99.8098 191.207Z",
    fill: "#EEEEEE"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3574 197.515C91.7027 197.766 91 197.282 91 196.581L91 191.938C91 191.266 91.65 190.785 92.2928 190.982L99.1089 193.069L99.1089 194.931L92.3574 197.515Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M149.893 198.028C150.55 198.537 151.505 198.068 151.505 197.237L151.505 191.208C151.505 190.411 150.617 189.934 149.952 190.375L145.891 193.069L145.891 194.931L149.893 198.028Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_8036_79226",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 191,
    width: 3,
    height: 6
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 143.396 191.828)",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_8036_79226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 143.396 191.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19 191.207C144.869 191.207 144.59 191.426 144.534 191.742C144.444 192.248 144.332 193.068 144.332 194C144.332 194.932 144.444 195.752 144.534 196.258C144.59 196.575 144.869 196.793 145.19 196.793C145.577 196.793 145.891 196.479 145.891 196.092L145.891 191.908C145.891 191.521 145.577 191.207 145.19 191.207Z",
    fill: "#EEEEEE"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.643 197.515C153.297 197.766 154 197.282 154 196.581L154 191.938C154 191.266 153.35 190.785 152.707 190.982L145.891 193.069L145.891 194.931L152.643 197.515Z",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 185,
    width: 18,
    height: 12,
    transform: "rotate(90 129 185)",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M123.611 198.644C121.787 198.644 120.755 197.696 120.755 195.872L120.755 192.98C120.755 191.168 121.763 190.196 123.635 190.196C125.315 190.196 126.251 190.964 126.311 192.404L125.279 192.404C125.207 191.576 124.655 191.156 123.647 191.156C122.411 191.156 121.811 191.78 121.811 193.04L121.811 194.192C122.315 193.604 123.023 193.316 123.923 193.316C125.507 193.316 126.419 194.216 126.419 195.92C126.419 197.672 125.459 198.644 123.611 198.644ZM123.611 197.684C124.787 197.684 125.351 197.072 125.351 195.944C125.351 194.852 124.811 194.276 123.731 194.276C122.807 194.276 122.159 194.708 121.811 195.572L121.811 195.848C121.811 197.084 122.435 197.684 123.611 197.684Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeBeaker3Tubes);
export default __webpack_public_path__ + "static/media/Large_Beaker_3Tubes.4075aa7d7eda1f0a543900287dd138e6.svg";
export { ForwardRef as ReactComponent };